import type { ClientPluginContext } from 'villus'
import { batch } from '@villus/batch'
import { cache, dedup, fetch } from 'villus'

import { getCookie } from '~/utils/utils'

function authPlugin({ opContext }: ClientPluginContext): void {
  const csrfCookie = getCookie('csrftoken')
  if (csrfCookie)
    opContext.headers['X-CSRFToken'] = csrfCookie
}

export const villusClientOptions = {
  url: '/graphql-batch',
  use: [dedup(), authPlugin, cache(), batch()],
}

export const villusClientOptionsWithoutBatching = {
  url: '/graphql',
  use: [authPlugin, cache(), fetch()],
}
